module.exports = __webpack_public_path__ + "media/src/assets/leaving_report_screen-ff7eb22e127ac0be1af58f344664d36b.png";